<template>
  <div id="login">
     <div class="bg"></div>
     <div class="body">
         <section class="section">
            <div class="title">Cicadas</div>
            <div class="form_box">
               <el-form ref="form" class="form"
                     :model="form" :rules="rules" label-position="left"  label-width="35">
                     <el-form-item label=" " prop="email">
                        <el-input type="text" placeholder="请输入邮箱" prefix-icon="el-icon-user" :disabled="isLoading" v-model="form.email" />
                     </el-form-item>
                     <el-form-item label=" " prop="password">
                        <el-input type="password" placeholder="请输入密码" prefix-icon="el-icon-unlock" :disabled="isLoading" v-model="form.password" />
                     </el-form-item>
                     <el-form-item label=" ">
                        <div class="midBox">
                           <el-checkbox  v-model="isAutoLoading">自动登录</el-checkbox>
                           <!-- <span class="link" @click="toRetriever">找回密码</span> -->
                           <!-- <el-link @click="toRetriever">找回密码</el-link> -->
                        </div>
                     </el-form-item>
                     <el-form-item>
                        <div class="buttons">
                           <el-button @click="login" type="success" style="width:100%;" :loading="isLoading">
                              登录</el-button>
                           <span class="link" @click="toRegister">注册</span>
                        </div>
                     </el-form-item>
               </el-form>
            </div>
            <!-- <div class="title">Login in Cicadas</div>
            <div class="inputBox">
               <div class="input">
                  <input class="_input" type="text" v-model="form.email" :disabled="isLoading" placeholder="Enter your work email address">
                  <div class="label">Email</div>
                  <div class="_border"></div>
               </div>
               <div class="errorTip" :class="{show: rules.email()}">{{rules.email()}}</div>
            </div>
            <div class="inputBox">
               <div class="input">
                  <input class="_input" type="password" v-model="form.password" :disabled="isLoading" placeholder="Enter your password">
                  <div class="label">Password</div>
                  <div class="_border"></div>
               </div>
               <div class="errorTip" :class="{show: rules.password()}">{{rules.password()}}</div>
            </div>
            <div>
               <el-checkbox  v-model="isAutoLoading">自动登录</el-checkbox >
            </div>
            <div class="buttonBox">
               <button class="button login" :disabled="isLoading" @click="login"> 
                  <span class="txt"> <i class="fa fa-circle-o-notch" :class="{show: isLoading}"></i>Login</span>
               </button>
            </div>
            <div class="tip">
               Already have a account? <a class="link" href="/#/register">Sign in</a>
               or <a class="link" href="/#/retriever">reset password</a>
            </div> -->
         </section>
         <!-- end section -->
         <!-- footer -->
         <footer class="footer_style_2">
            <div class="footer_bottom">
            <p>© 2020 Cicadasing Technology LLC. All rights reserved.</p>
            </div>
         </footer>
     </div>
  </div>
</template>
<style lang="scss">
.header.login{
   background:transparent;
   box-shadow: none;
   .menu{
      li a{
         color:#fff;
      }
   }
}
#login{
   display:flex;
   flex-direction: column;
   .bg{
      width:100vw;
      height:100vh;
      position:fixed;
      left:0;top:0;
      background:url("../assets/img2/login_bg.jpeg") no-repeat center center;
      background-size:100%;
      z-index: -33;
   }
   .footer_bottom{
      background:transparent;
   }
   .link{
      color:#3FB8A4;
      cursor: pointer;
   }
   .midBox{
      padding:0 8px;
      display:flex;
      justify-content: space-between;
   }
   .buttons{
      display:flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .link{
         cursor: pointer;
      }
   }
   .body{
      position: relative;
      z-index: 1;
      display:flex;
      justify-content: center;
      flex-direction: column;
      .section{
         // margin:3% auto 5% auto;
         
         min-height: calc(100vh - 150px);
         margin: 0 auto;
         padding: 3% 0 5% 0;
         .title{
            text-align: center;
            font-weight: bold;
            font-size: 32px;
            color:#fff;
            margin-bottom: 15px;
         }
         .form{
            background:#fff;
            width:80vw;
            max-width: 368px;
            padding: 30px 20px 15px 20px;
            box-shadow: 0px 4px 8px 0px rgba(0, 79, 66, 0.16);
            border-radius: 2px;
         }
      }
   }
   .footer_style_2{
      background:transparent;
   }
   .el-form-item{
      display: flex;
      .el-form-item__label{
         width:20px;
      }
      .el-form-item__content{
         flex-grow: 1;
      }
   }
}
@media screen and (max-width: 600px){
    #login{
      .bg{
         background-size:auto 100%;
      }
    }
}
</style>

<script>
import encrypt from "@/public/method/encrypt";
import server from "@/public/service"
import {SUCCESS_CODE} from "@/public/state";
import getInterfaceData from "@/public/service/getInterfaceData";
import loginCallback from "@/public/method/loginCallback"
export default {
  title: "Dingo Group",	
  data() {
    return {
         form:{
            email:"",
            password:"",
         },
         isLoading: false,
         rules:{
            email:[
               {
                  required:true,message:"邮箱不能为空",trigger: 'blur'
               },
               { validator:(scope=>(rule, value, callback) => {
                     if (!value.match(/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/)) {
                        callback(new Error('邮箱格式不正确！'));
                     } else{
                        callback()
                     }
               })(this), trigger: 'blur' },
            ],
            password:[{
               required:true,message:"密码不能为空",trigger: 'blur' 
            }]
         },
         isAutoLoading: false
      //  rules: {
      //     email: this.emailVerfy,
      //     password: this.passwordVerfy
      //  },
    };
  },
  methods: {
     emailVerfy(){
        if(!this.form.email){
           return '请填写邮箱！';
        };
        if(!this.form.email.match(/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/)){
           return '邮箱格式不正确！';
        }
        return false;
     },
     passwordVerfy(){
        if(!this.form.password){
           return '请填写密码！';
        };
        return false;
     },
     verify(){
        return new Promise((res,rej)=>{
            for(var i in this.rules){
               if(this.rules[i]()){
                  return rej();
               }
            };
            return res();
        })
     },
     login(){
      //   console.log("login")
      //   this.isLoading = true;
      //   setTimeout(()=>{
      //      this.isLoading = false;
      //   },10000)
         this.$refs["form"].validate((valid) => {
            if (valid) {
               this.isLoading = true;
               server.login({
                  email: this.form.email,
                  password: encrypt(this.form.password)
               }).then(data=>{
                  if(data.reCode === SUCCESS_CODE){
                     var result = getInterfaceData(data);
                     var storage = this.isAutoLoading ? window.localStorage : window.sessionStorage;
                     loginCallback.call(this,result,storage);
                  }
               }).finally(()=>{
                  this.isLoading = false;
               }) 
            } else {
               return false;
            }
         });
     },
     toRegister(){
        this.$router.push("/register");
     },
     toRetriever(){
        this.$router.push("/retriever");
     }
  },
  created(){
     console.log('this.$store',this.$store);
  }
};
</script>
